<template >
  <section id="privacy">
    <div id="main">
      <div class="container">
        <div>
          <h2>1. What are cookies</h2>
          <div class="subtitle">
            Cookies are text files sent by a web server (namely, the computer that “hosts” the visited website) to the user’s browser (Internet Explorer, Firefox, Google Chrome, etc.) and stored on the device, either fixed or mobile (computer, smartphone, tablet), used by the user for browsing. Cookies allow the Website to identify the user’s device through the stored information each time the user reconnects itself to the Website through that device.
            <br/><br/>
            By using cookies, it is possible to make it easier for the user to browse the Website and to analyse their preferences and tastes by checking their browsing history, and consequently to offer products and provide services more consistent with the interests and expectations of said user.
            <br/><br/>
            Cookies may be “session cookies” (when they are stored only for the duration of the browsing session and are cancelled when the session is closed), or “permanent cookies” (that are stored for longer periods, until their expiry or cancellation by the user). Further, cookies may be installed by the website the user is visiting (so-called first party cookies) or may be installed by other websites (so-called third party cookies).
            <br/><br/>
            Cookies do not collect direct personal data information concerning the user. In fact, Audi PML cannot, by means of cookies, directly obtain any personal data information (e.g. name, surname), unless expressly provided by the client.
          </div>
          
          <h2>2. Cookies used by Audi PML</h2>
          <div class="subtitle">
            Browsing or session technical cookies
            <br/><br/>
            Audi PML uses browsing or session technical cookies to allow normal and efficient browsing and use of the Website. Such cookies do not require the preventive and express consent of the user since they are closely linked to the provision of the service requested by the user of the Website.
            <br/><br/>
            Analytical cookies
            <br/><br/>
            Audi PML, in its capacity as manager of the Website, uses third parties’ analytical cookies to collect information on the Website used by the users (number of visitors, visited pages, permanence on the Website, etc.) to prepare statistical analysis, on an aggregated basis, on the number of users and on how users browse our Website. To use such cookies, criteria for masking the source of the IP address have been adopted.
            <br/><br/>
            Such cookies do not require the prior and express consent of the user since they are closely linked to the provision of the service requested by the user of the Website.
            <br/><br/>
            Third party profiling cookies
            <br/><br/>
            Audi PML uses third party profiling cookies (namely cookies that are issued and managed by parties other than Audi PML) to send advertising messages in line with the preferences manifested by the user while browsing.
            <br/><br/>
            This category of cookies includes third party social media cookies that allow information on the user’s social network use to be collected.
            <br/><br/>
            The use of such cookies requires the express and informed consent of the user.
          </div>

          <h2>3. Managing your choices about cookies</h2>
          <div class="subtitle">
            Upon accessing any page of the Website, a banner including some brief information on the cookies used by Audi PML is displayed. By providing your authorisation through the banner, you consent to the use of profiling cookies.
            <br/><br/>
            Please note that your consent will be required only upon your first access to the Website: afterwards, due to the use of a technical cookie, we will store your consent to allow you to directly access the Website pages on your return (without prejudice to your right to disable/enable the cookies or to delete them at any time: in this case, on your return, the Website will require your consent once more).
            <br/><br/>
            It is possible to disable/enable or delete the cookies at any time by using the settings of your Web browser. In particular, if you do not wish to receive cookies, it is possible to set your own browser to inform you of the presence of a cookie, thus allowing you to decide whether to accept it or not; you may also automatically refuse all the cookies by enabling the specific browser option. You may also delete specific cookies already stored in the browser or block the storage of cookies on your computer by specific websites, or block third party cookies.
            <br/><br/>
            Below, find the methods provided by the main browsers:
          </div>
          <div class="content-list">
            <ul>
              <li><i class="iconfont">&#xe610;</i>Internet Explorer (<a href="https://support.microsoft.com/en-hk/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">https://support.microsoft.com/en-hk/help/17442/windows-internet-explorer-delete-manage-cookies</a>)</li>
              <li><i class="iconfont">&#xe610;</i>Chrome (<a href="https://support.google.com/chrome/answer/95647" target="_blank">https://support.google.com/chrome/answer/95647</a>)</li>
              <li><i class="iconfont">&#xe610;</i>Firefox (<a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank">https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer</a>)</li>
              <li><i class="iconfont">&#xe610;</i>Opera  (<a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank">https://help.opera.com/en/latest/web-preferences/#cookies</a>)</li>
              <li><i class="iconfont">&#xe610;</i>Safari (<a href="https://support.apple.com/en-hk/HT201265" target="_blank">https://support.apple.com/en-hk/HT201265</a>)</li>
            </ul>
          </div>
          <div class="subtitle">
            Following the disabling of all cookies, some functions of the website pages may not operate correctly.
          </div>

          <h2>4. Data Protection Officer of our Company</h2>
          <div class="subtitle">
            For further information on the processing of your personal data through the Website, please visit the&nbsp;<router-link to="/privacypolicy">Privacy Policy</router-link> 
          </div>


        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "privacyPolicy",
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
  #privacy {
    counter-reset: num;
    h2 {
      font-family: 'AudiTypeBold';
      font-size: 22px;
      margin: 18px 0;
    }
    .subtitle {
      line-height: 19px;
      margin-bottom: 18px;
    } 
    .content {
      line-height: 22px;
      margin-bottom: 38px;
    }
    .content-list {
      padding-left: 18px;
      padding-right: 18px;
      margin-bottom: 38px;
      ul {
        font-size: 15px;
        li {
          line-height: 24px;
          margin-top: 6px;
          .iconfont {    
            font-size: 17px;
            font-weight: 600;
            margin-right: 12px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/help/Cookie.vue